import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

// nginx drops headers that contain underscores. Copy auth onto hyphenated names.
axios.interceptors.request.use((config) => {
  const headers = config.headers;
  const read = (name) => headers?.get?.(name) || headers?.[name];
  const userId = read("user-id") || read("user_id") || localStorage.getItem("user_id");
  const apiKey = read("api-key") || read("api_key") || localStorage.getItem("user_api_key");
  if (userId) {
    headers.set ? headers.set("user-id", userId) : (headers["user-id"] = userId);
  }
  if (apiKey) {
    headers.set ? headers.set("api-key", apiKey) : (headers["api-key"] = apiKey);
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);




